import type { ChangePasswordInput, UpdateProfileInput } from '@crm/shared';
import { apiClient } from '@/lib/api-client';
import { AUTH_ENDPOINTS } from '../constants';
import type {
  AuthResponse,
  ConnectedAccount,
  HealthResponse,
  MeResponse,
  PermissionsCatalog,
  PublicUser,
  QueueCounts,
  SocialSignInResponse,
} from '../types';

/** Chamadas HTTP do modulo de auth (uma funcao por endpoint documentado). */
export const authService = {
  register(input: { name: string; email: string; password: string }) {
    return apiClient.post<AuthResponse>(AUTH_ENDPOINTS.REGISTER, input);
  },

  login(input: { email: string; password: string; rememberMe?: boolean }) {
    return apiClient.post<AuthResponse>(AUTH_ENDPOINTS.LOGIN, input);
  },

  connectedAccounts() {
    return apiClient.get<{ data: ConnectedAccount[] }>(AUTH_ENDPOINTS.ACCOUNTS);
  },

  switchAccount(userId: string) {
    return apiClient.post<MeResponse>(AUTH_ENDPOINTS.SWITCH, { userId });
  },

  logout() {
    return apiClient.post<{ message: string }>(AUTH_ENDPOINTS.LOGOUT);
  },

  /** Troca o ID token do Google Identity Services por uma sessao Better Auth. */
  loginWithGoogle(credential: string) {
    return apiClient.post<SocialSignInResponse>(AUTH_ENDPOINTS.GOOGLE_SIGN_IN, {
      provider: 'google',
      idToken: { token: credential },
    });
  },

  me() {
    return apiClient.get<MeResponse>(AUTH_ENDPOINTS.ME);
  },

  updateProfile(input: UpdateProfileInput) {
    return apiClient.patch<PublicUser>(AUTH_ENDPOINTS.ME, input);
  },

  changePassword(input: ChangePasswordInput) {
    return apiClient.post<{ message: string }>(AUTH_ENDPOINTS.CHANGE_PASSWORD, input);
  },

  forgotPassword(email: string) {
    return apiClient.post<{ message: string }>(AUTH_ENDPOINTS.FORGOT_PASSWORD, { email });
  },

  resetPassword(input: { token: string; password: string }) {
    return apiClient.post<{ message: string }>(AUTH_ENDPOINTS.RESET_PASSWORD, input);
  },

  permissions() {
    return apiClient.get<PermissionsCatalog>(AUTH_ENDPOINTS.PERMISSIONS);
  },

  health() {
    return apiClient.get<HealthResponse>(AUTH_ENDPOINTS.HEALTH);
  },

  queues() {
    return apiClient.get<QueueCounts>(AUTH_ENDPOINTS.QUEUES);
  },
};
